import { MinhaContaComponentProvider } from "@/components/MinhaContaComponent";
import { AdminContext } from "@/contexts/AdminContext";
import { useContext, useEffect } from "react";

function MinhaConta() {
  const { isAdmin, requireAdmin } = useContext(AdminContext)!;

  useEffect(() => {
    requireAdmin(() => {
      // Ação a ser executada se o usuário for admin
    });
  }, []);
  return (
    <div className="flex flex-col gap-4 py-4 md:gap-6 md:py-6 px-4 lg:px-6">
      {isAdmin ? (
        <MinhaContaComponentProvider />
      ) : (
        <div className="text-center text-gray-500">
          Acesso restrito. Apenas administradores podem acessar esta página.
        </div>
      )}
    </div>
  );
}

export default MinhaConta;
